import { ReactNode } from 'react';
import styled from 'styled-components';

const Root = styled.div`
  height: 100%;
  display: grid;
  grid-template-rows: 1fr auto 1fr;
`;
const Footer = styled.div`
  margin-top: auto;
`;

export const CenterVertically = ({
  children,
  footer,
}: {
  children: ReactNode;
  footer?: ReactNode;
}) => {
  return (
    <Root>
      <div />
      <div>{children}</div>
      <Footer>{footer}</Footer>
    </Root>
  );
};
